import { ColumnView, ColumnWithTranslation } from '../../../models';
import { Mapper } from '../../../mappers';
import { ColumnSetup } from '../models/column-setup';
import { EntityType } from '../models/entity-type';

export class ColumnViewMapper extends Mapper<ColumnSetup, ColumnView> {
  constructor(
    private readonly createColumn: (
      template: string,
      header: string,
      width?: number,
    ) => ColumnWithTranslation,
    private readonly defaultColumns: ColumnWithTranslation[],
  ) {
    super();
  }

  // A saved view without columns keeps its key, so saving it again does not create another one.
  from(source: ColumnSetup): ColumnView {
    const columns = (source.Columns ?? []).map((item) =>
      this.createColumn(item.Template ?? '', item.Header ?? '', item.Width),
    );

    return {
      key: source.Key,
      rank: source.Rank,
      columns: columns.length ? columns : this.defaultColumns,
    };
  }
}

export class ColumnSetupMapper extends Mapper<ColumnView, ColumnSetup> {
  constructor(
    private readonly defaultWidth: number,
    private readonly entityType: EntityType,
  ) {
    super();
  }

  // The server returns columns in ID order, so IDs are renumbered in display order.
  from(source: ColumnView): ColumnSetup {
    return {
      Key: source.key,
      Rank: source.rank,
      EntityType: this.entityType,
      Columns: source.columns.map((item, index) => ({
        ID: `C${index}`,
        Header: item.title?.defaultText ?? '',
        Template: item.field,
        Width: Math.round(item.size ?? this.defaultWidth),
      })),
    };
  }
}
